// Module
var code = "<div class=\"open-condition-builder-dialog\"> <slot name=\"content\"> <a href=\"#\" @click.stop.prevent=\"open()\" :title=\"title\"> <slot></slot> </a> </slot> </div> ";
// Exports
export default code;